import { render, staticRenderFns } from "./OneStep.vue?vue&type=template&id=c06749b2&scoped=true&"
import script from "./OneStep.vue?vue&type=script&lang=js&"
export * from "./OneStep.vue?vue&type=script&lang=js&"
import style0 from "./OneStep.vue?vue&type=style&index=0&id=c06749b2&scoped=true&lang=scss&"
import style1 from "./OneStep.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06749b2",
  null
  
)

export default component.exports